import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  Inject,
  LOCALE_ID
} from '@angular/core';
import { PlaceOrderComponent } from '@schoolbelle/shared/components';
import { startWith } from 'rxjs/operators';
import { GroupService } from '@schoolbelle/api/group';
import { LedgerService } from '@schoolbelle/api/ledger';
import { PurchaseService } from '@schoolbelle/api/purchase';
import { UserToGroupService } from '@schoolbelle/api/user-to-group';
import { LoadingService } from '@schoolbelle/common/loading';
import { DialogService } from '@schoolbelle/common/dialog';
import { TranslationService } from '@schoolbelle/common/translation';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'place-order-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.css']
})
export class PlaceOrderSmsComponent extends PlaceOrderComponent
  implements OnInit {
  @Output() onUpdated = new EventEmitter();
  constructor(
    group: GroupService,
    ledger: LedgerService,
    purchase: PurchaseService,
    utg: UserToGroupService,
    cdRef: ChangeDetectorRef,
    @Inject(LOCALE_ID) locale_id: string,
    protected translation: TranslationService,
    protected loading: LoadingService,
    protected dialogs: DialogService
  ) {
    super(group, ledger, purchase, utg, cdRef, locale_id);
  }
  ngOnInit() {
    this.orderType = 'sms';
    super.ngOnInit();
    this.subscriptions.add(
      this.form.valueChanges
        .pipe(startWith(this.form.value))
        .subscribe((model: any) => {
          this.onUpdated.next({
            invalid: this.form.invalid,
            data: this.buildParams(model)
          });
        })
    );
  }
  fillInBasicValues() {
    super.fillInBasicValues();
    // this.paymentType.setValue('virtualAccount');
  }

  order() {
    const ob = super.order();
    const subscription = ob.subscribe(
      () => {
        alert(this.translation.get('place-order-ordered'));
      },
      (e: HttpErrorResponse) => {
        switch (e.status) {
          case 429:
            alert(this.translation.get('place-order-429-error'));
            break;
          default:
            alert(this.translation.get('place-order-unknown-error'));
        }
      }
    );
    this.loading.open({
      message: this.translation.get('place-order-ordering'),
      busy: subscription
    });
    return ob;
  }
}
